import { Box } from "./Box";
import { Tag } from "../Tag";

let _MediaPaneCtor: any;
export function registerMediaPaneCtor(ctor: any): void { _MediaPaneCtor = ctor; }

export class Pane extends Box {
    protected createByType(data: Map<any, any>, main: Tag) {
        switch (data.get("t")) {
            case "pn":
                main.appendChild(new Pane(data));
                break;
            case "mp":
                if (_MediaPaneCtor) { main.appendChild(new _MediaPaneCtor(data)); }
                break;
            default:
                super.createByType(data, main);
                return;
        }
    }

    protected createSelf() {
        super.createSelf();
        this.addClass("pane");
    }
}
